const immyz = {
    id: 'immyz',
    publicSiteName: 'IMMYZ',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#8d5b18',
            secondary: '#111111',
            color1: '#ddbb6b',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/immyz/favicon.ico',
        logo: '/immyz/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default immyz